import { render, staticRenderFns } from "./ParticaIssue.vue?vue&type=template&id=14754c20&"
import script from "./ParticaIssue.vue?vue&type=script&lang=ts&"
export * from "./ParticaIssue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports